import palette from '@telus-uds/palette-koodo';
var color = palette.color;
export var udsColors = color;
export var udsColorNames = Object.keys(color);
export var TYPOGRAPHY_COLORS = [
    'default',
    'brand',
    'dark',
    'light',
    'positive',
    'warning',
    'danger',
    'black',
    'white',
    'brand2',
    'brand3',
    'alternative1',
    'alternative2',
    'alternative3'
];
export var PARAGRAPH_COLORS = ['secondary', 'tertiary', 'inverse'];
